import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function PendingReviewEmptyState({ icon, titleKey, descriptionKey }) {
  return (
    <DashboardEmptyStateCard
      icon={icon}
      title={Trans(translations, titleKey)}
      description={Trans(translations, descriptionKey)}
    />
  );
}

export default PendingReviewEmptyState;
